import { useNavigate } from 'react-router-dom';
import Button1 from '../../Components/UI/Button1/Button1';
import classes from './Reg.module.css'

const RegResult = () => {
    const nav = useNavigate()
    return ( 
    <div className={classes.reg}>
    <div className={classes.container} style={{gap:"20px"}}>
                    <div className={classes.formName} style={{textAlign:"center"}}>
                        Создание аккаунта успешно завершено!
                        <br/>
                        На почту отправлен пароль для авторизации
                    </div>
                    <Button1 onClick={()=>nav('/auth')}>
                        Перейти к авторизации
                    </Button1>
                </div>
    </div>
     );
}
 
export default RegResult;